<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="RELATÓRIOS DE TESOURARIA"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/print.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="form-group col-md-6">
        <label for="mes">Selecione o relatório</label>
        <select [(ngModel)]="relatoriosSelect" name="selectRelatorios" style="font-weight: bold; color: #1565c0"
          class="custom-select custom-select-sm">
          <option [selected]="item.id === relatoriosSelect" [value]="item.id" *ngFor="let item of listaRelatorios">
            {{item.nome}}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-2" *ngIf="relatoriosSelect === 'BOLETIM_BANCO' || relatoriosSelect === 'CONCILIACAO_BANCARIA'">
        <label for="data_inicial">Data inicial</label>
        <p-calendar [(ngModel)]="dataCaixa" id="data_inicial" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
          [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="form-group col-md-2" *ngIf="relatoriosSelect !== 'BOLETIM_BANCO' && relatoriosSelect !== 'CONCILIACAO_BANCARIA'">
        <label for="data_inicial">Selecione a data</label>
        <p-calendar [(ngModel)]="dataCaixa" id="data_inicial" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
          [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="form-group col-md-2" *ngIf="relatoriosSelect === 'BOLETIM_BANCO' || relatoriosSelect === 'CONCILIACAO_BANCARIA'">
        <label for="data_termino">Data Final</label>
        <p-calendar [(ngModel)]="dataFinal" id="data_termino" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
          [style]="{ width: '100%' }">
        </p-calendar>
      </div>
    </div>
    <div class="row mt-3">
      <div class="form-group col-md-2">
        <a (click)="imprimirPdf()" class="btn btn-sm btn-outline-secondary">
          <img src="assets/img/global/file_pdf.png" alt="cvs" title="Gerar pdf" height="20" width="20">
          Gerar PDF
        </a>
      </div>
    </div>

  </div>
</div>